import { render, staticRenderFns } from "./SellerComission.vue?vue&type=template&id=8496af34&scoped=true&lang=html&"
import script from "./SellerComission.vue?vue&type=script&lang=ts&"
export * from "./SellerComission.vue?vue&type=script&lang=ts&"
import style0 from "./SellerComission.vue?vue&type=style&index=0&id=8496af34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8496af34",
  null
  
)

export default component.exports